var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-combobox',_vm._b({attrs:{"items":_setup.llmTags},model:{value:(_setup.newValue),callback:function ($$v) {_setup.newValue=$$v},expression:"newValue"}},'v-combobox',_setup.currentProperties(),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }